import React from 'react';
import styled from 'styled-components';

const TopSpacer = props => {
    return(
        <El />
    );
}

export default TopSpacer;

const El = styled.div`
    height:130px;
    @media (max-width: 767px) {
        height:90px;
    }
`


// WEBPACK FOOTER //
// ./src/partials/TopSpacer.js